import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../stores/actionsList";
import { bindActionCreators } from "redux";
import { NotebookList } from "./NotebookList";
import NotebookEditor from "./NotebookEditor";
import StagesManager from "../components/StagesManager";
import HttpServices from "../utils/Http.services";
import { checkActiveStyles, createSpanWithStyle, findRangeSelectedSpans, getStyleObject, changeSelectedTextEffects, textEffectsList } from "../variables/notebook";
import { nanoid } from "nanoid";
import Header from "../components/header/Header";
import { chooseFontColor } from "../utils/useful";
export class Notebook extends Component {
    state = {
        id: "",
        textEffectsList: [...textEffectsList],
        editorId: nanoid(),
        headerConfig: {
            showToolbar: true, showSettings: false, showSettings: false, isPortal: true, title: '{{lang}}Notebook', type: 'notebook'
        },
        showToolbar: true,
        colors: {
            primaryColor: '#FFA01C',
            secondaryColor: '#F0C000',
            textColor: '#fff'
        }
    };
    componentDidMount() {

        if (this.props.data.path && this.props.data?.path[1]) {
            this.getNote(this.props.data?.path[1]);
            this.stageManager.changeStage("editor");
        } else {
            this.stageManager.changeStage("list");
        }
        if (this.props.defaultHeaderConfig) {
            this.setState({ headerConfig: this.props.defaultHeaderConfig })
        }
        this.init();
    }

    componentDidUpdate() {
        if (this.props.data.path && this.props.data?.path[1] && this.props.data?.path[1] != this.state.id && this.props.lastSelected) {
            this.getNote(this.props.data?.path[1]);
            this.stageManager.changeStage("editor");
        }
        // this.init()
    }

    resetId = () => {
        this.setState({ id: {} })
    }

    changeNotePage = (page) => {
        let path;
        if (page) {
            if (Array.isArray(page)) {
                path = page;
            } else {
                path = [page?.key ?? page];
            }
        }
        this.changeWindowLink(path);
    };

    changeWindowLink = (nPath) => {
        // let path = ['notebook']
        // if(this.props.data.path){

        // path = this.props.data.path
        let path = this.props.data.path;
        // }
        // if(path?.length > 0){
        //     path = [path[0], path[1]]
        //     if (nPath != null) {
        //         // path = [...path, ...nPath]
        //         for (let i = 0; i < nPath.length; i++) {
        //             if (nPath[i] != path.at(-1)) {
        //                 path.push(nPath[i])
        //             }
        //         }
        //     }
        // }else{
        path = nPath;
        // }
        // if (nPath != null && !path.includes(nPath[0])) {
        //     path = [...path, ...nPath]
        // }
        this.props.changeWindow("notebook", { path: path });
    };

    init = () => {
        HttpServices.request("getNotes", {}, (fetchResolve, fetchError) => {
            if (fetchError) { }
            this.setState({ notes: fetchResolve?.info });
        });
    };

    getNote = (id) => {
        HttpServices.request(
            "getNote",
            { _id: id },
            (fetchResolve, fetchError) => {
                if (fetchError) {
                }
                let currentPage
                if (fetchResolve?.info?.content && fetchResolve?.info?.content[0]) {
                    currentPage = fetchResolve?.info?.content[0]
                }
                this.setState({ note: fetchResolve?.info, currentPage }, () => {
                    this.setState({ id, titleValue: this.state.note?.title, });
                });
            }
        );
    };

    saveDoc = (id) => {
        let data = { title: this.state.titleValue };
        if (id) {
            data._id = id;
        }
        // this.setState({ bodyValue: '' })
        HttpServices.request("saveDoc", data, (fetchResolve, fetchError) => {
            if (fetchError) {
            }
            this.init();
            this.changeNotePage(['notebook'])
            this.stageManager.changeStage("list");
            this.setState({ titleValue: "" });
        });
    };

    updateNote = (id) => {
        // let content = document.getElementById(this.state.editorId).getInputValue();
        let pageInfo = [{ body: this.notebookEditor.getContent(), pagename: '1st Page' }]
        let data = { title: this.state.titleValue, content: pageInfo };
        data._id = id;
        // this.setState({ bodyValue: '' })
        HttpServices.request("updateNote", data, (fetchResolve, fetchError) => {
            if (fetchError) {
            }
            this.init();
            this.changeNotePage(['notebook'])
            this.stageManager.changeStage("list");
            this.setState({ titleValue: "" });
        });
    };

    titleValue = (e) => {
        this.setState({ titleValue: e.target.value }, () => { });
    };


    updateTextEffectsStyleStatus = (activeStyles = []) => {
        const textEffectsList = [...this.state.textEffectsList];
        textEffectsList.forEach(textEffect => {
            const activeStyle = activeStyles.find(activeStyle => activeStyle === textEffect.styleName);
            if (activeStyle) {
                textEffect.isStyleActive = true
            } else {
                textEffect.isStyleActive = false

            }
        })
        this.setState({ textEffectsList })
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    functionsHandler = (type, name, data, info) => {
        if (type) {
            if (this[type] && this[type][name]) {
                this[type][name](data)
            }
        } else {
            if (this[name]) {
                this[name](data, info)
            }
        }
    }

    render() {
        let colors = this.state.colors ?? {}

        // console.log('coloooooooooooooooor', this.props)
        if (this.props.user.info?.colorType == 'sameAsHub') {
            if (this.props.user.info.colors) {
                colors = this.props.user.info.colors
            }
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        return (
            <div className="w-100 d-flex flex-column window-content-radius h-100" style={{ backgroundColor: "#fff" }}>
                <div style={{ position: 'relative', top: 0 }}>
                    <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} />
                </div>
                {/* <div className="w-100 h-100 scroll-no-scrollbar "> */}
                <StagesManager ref={(el) => (this.stageManager = el)} height={'0px'} className={'flex-1'}>
                    <NotebookList
                        language={this.props.settings.language}
                        width={this.props.width}
                        changeNotePage={this.changeNotePage}
                        resetId={this.resetId}
                        isLoading={this.props.isLoading}
                        notes={this.state.notes}
                        stage={0}
                        stageName={"list"}
                        setHeader={this.setHeader}
                        colors={colors}
                        isDesktop={this.props.isDesktop}
                    />
                    <NotebookEditor
                        ref={el => this.notebookEditor = el}
                        currentPage={this.state.currentPage}
                        changeSelectedTextEffects={(effectType, id) =>
                            changeSelectedTextEffects(effectType, id, this.updateTextEffectsStyleStatus)
                        }
                        editorId={this.state.editorId}
                        updateTextEffectsStyleStatus={this.updateTextEffectsStyleStatus}
                        textEffectsList={[...this.state.textEffectsList]}
                        language={this.props.settings.language}
                        width={this.props.width}
                        data={this.props.data}
                        note={this.state.note}
                        changeNotePage={this.changeNotePage}
                        titleValue={this.titleValue}
                        title={this.state.titleValue}
                        saveDoc={this.saveDoc}
                        updateNote={this.updateNote}
                        isLoading={this.props.isLoading}
                        stage={1}
                        stageName={"editor"}
                        setHeader={this.setHeader}
                        colors={colors}
                        isDesktop={this.props.isDesktop}
                    />
                </StagesManager>
                {/* </div> */}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    settings: state.settings,
    user: state.user
});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Notebook);
